import { defineMessages } from 'react-intl';

export default defineMessages({
    filtersTypeMesssage: {
        id: 'adac.communicationHistory.filters.type.message',
        defaultMessage: 'Messages'
    },
    filtersTypeDocuments: {
        id: 'adac.communicationHistory.filters.type.documents',
        defaultMessage: 'Documents'
    },
    filtersTypeCallbackRequest: {
        id: 'adac.communicationHistory.filters.type.callbackRequests',
        defaultMessage: 'Callback requests'
    },
    filtersTypeShowAll: {
        id: 'adac.communicationHistory.filters.type.all',
        defaultMessage: 'Show all'
    },
    dateColumnHeader: {
        id: 'adac.communicationHistory.datatable.Date',
        defaultMessage: 'Date'
    },
    fromColumnHeader: {
        id: 'adac.communicationHistory.datatable.From',
        defaultMessage: 'From'
    },
    fromColumnADAC: {
        id: 'adac.communicationHistory.datatable.ADAC',
        defaultMessage: 'ADAC'
    },
    fromColumnMember: {
        id: 'adac.communicationHistory.datatable.Member',
        defaultMessage: 'Member'
    },
    typeColumnHeader: {
        id: 'adac.communicationHistory.datatable.Type',
        defaultMessage: 'Type'
    },
    typeColumnMessage: {
        id: 'adac.communicationHistory.datatable.Message',
        defaultMessage: 'Message'
    },
    typeColumnDocument: {
        id: 'adac.communicationHistory.datatable.Document',
        defaultMessage: 'Document'
    },
    typeColumnCallback: {
        id: 'adac.communicationHistory.datatable.Callback from ADAC',
        defaultMessage: 'Callback from ADAC'
    },
    typeColumnClaimCreation: {
        id: 'adac.communicationHistory.datatable.Claim creation',
        defaultMessage: 'Claim creation'
    },
    contentColumnHeader: {
        id: 'adac.communicationHistory.datatable.Content',
        defaultMessage: 'Content'
    }
});
